import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type {
  FeedMonitoringAlertDto,
  FeedMonitoringAlertsFilterInput,
  FeedMonitoringAlertsPagedInput,
  FeedMonitoringLiveResultDto,
  FeedMonitoringSaveAlertsInput,
  FeedMonitoringSaveSettingInput,
  FeedMonitoringSummaryDto,
} from '@/api/types/feedMonitoring';

const BASE = '/api/app/feed-monitoring';

export const feedMonitoringApi = {
  getLiveMonitoring: () =>
    http.get<FeedMonitoringLiveResultDto>(`${BASE}/live-monitoring`).then((r) => r.data),
  getAlertsPaged: (input: FeedMonitoringAlertsPagedInput) =>
    http
      .get<PagedResult<FeedMonitoringAlertDto>>(`${BASE}/alerts-paged`, { params: input })
      .then((r) => r.data),
  getAlertsSummary: (input: FeedMonitoringAlertsFilterInput) =>
    http
      .get<FeedMonitoringSummaryDto>(`${BASE}/alerts-summary`, { params: input })
      .then((r) => r.data),
  saveSetting: (input: FeedMonitoringSaveSettingInput) =>
    http.post(`${BASE}/setting`, input).then((r) => r.data),
  saveSettingAlerts: (input: FeedMonitoringSaveAlertsInput) =>
    http.post(`${BASE}/setting-alerts`, input).then((r) => r.data),
};
